
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/buying/buy-now-process",
      function () {
        return require("private-next-pages/content/buying/buy-now-process.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/buying/buy-now-process"])
      });
    }
  